var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-4 hidden-sm-and-down"},[_c('v-card-text',[_vm._t("header"),(_vm.options)?_c('highcharts',{ref:"highcharts",attrs:{"options":_vm.options}}):_vm._e(),_vm._t("footer")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }